import React from 'react'
import { Divider, MenuItem } from '@mui/material'
import { useNavigate } from 'react-router'
import { useUser } from '../../generic/hooks/useUser'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

/**
 * Story 213, reopening 2 (PO 2026-10-22, C14.3, DR-3) — "Camera control" in the gear menu of the top bar, beside
 * BackofficeMenuItem, for the profile ADMIN only (S265): ADMIN has no BACKOFFICE, so this is its way in; SUPERADMIN reaches
 * it through BACKOFFICE, and the entry there was repeated (PO 2026-10-23).
 *
 * @param {{ onClose: function }} props
 */
const CameraControlMenuItem = ({ onClose }) => {
  const { user } = useUser()
  const { t_ } = useSmartTranslation()
  const navigate = useNavigate()

  if (user?.profile?.code !== 'ADMIN') {
    return null
  }

  const handleClick = () => {
    onClose()
    navigate('/backoffice/cameraControl')
  }

  return (
    <>
      <Divider />
      <MenuItem onClick={handleClick} role='menuitem'>
        {t_('Camera control')}
      </MenuItem>
    </>
  )
}

export default CameraControlMenuItem
